import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';

interface UniqueSellingPropositionProperties {
  items: {
    id: string;
    icon: ReactElement;
    text: string;
  }[];
}

const Container = styled.div`
  text-align: center;
  padding-top: 5rem;
`;

const UniqueSellingPropositionContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;

  @media (min-width: ${breakpoints.md}px) {
    flex-direction: row;
    justify-content: space-around;
  }
`;

const UniqueSellingPropositionItem = styled.div`
  margin: 1rem 0;

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 1rem;
    text-align: center;
  }
`;

const Icon = styled.div`
  font-size: 2em;
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.primary};
  max-width: 24px;
  height: 48px;
  padding: 0 12px;
  margin: 0 auto;
  border-radius: .375rem;
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  margin-top: 1rem;
  max-width: 48rem;
`;

const UniqueSellingProposition = ({
  items,
}: UniqueSellingPropositionProperties) => (
  <Container>
    <UniqueSellingPropositionContainer>
      {items.map(({ id, icon, text }) => (
        <UniqueSellingPropositionItem key={id}>
          <Icon>{icon}</Icon>
          <Text>{text}</Text>
        </UniqueSellingPropositionItem>
      ))}
    </UniqueSellingPropositionContainer>
  </Container>
);

export default UniqueSellingProposition;
